import React, {h} from "preact";
import {Card, FR} from "../../../_common/layout";
import Badge from "../../../_common/components/Badge";
import {ButtonGhost} from "../../../_common/components/buttons/buttons";
import {t} from "../../../_i18n";
import {useHistory} from "react-router-dom";
import {connect} from "react-redux";
import {setExamSelected, openCartLink} from "../../../_rx/enrollment/exams/actions";
import ButtonSpinner from "../../../_common/components/buttons/buttonSpinner/buttonSpinner";
import {useState} from "preact/hooks";
import {toastService} from "../../../_services/toast-service";
import axios from "axios";

function CardUpcomingExamView({event, setExamSelected, isNextTerm}) {
    const history = useHistory()
    const [showSpinner, setShowSpinner] = useState(false)

    const handleClick = () => {
        history.push(`/examenes/apply`)
        setExamSelected(event)
    }

    const handleCreateCart = async () => {
        setShowSpinner(true);
        try {
            const generateCartResp = await axios.get(event.cart_url);

            if (generateCartResp.data && generateCartResp.data.cart_url) {
                window.open(generateCartResp.data.cart_url, '_blank');
            } else {
                toastService.showToast({message: t('error_cart_link'), type: 'danger'});
            }
        } catch (err) {
            toastService.showToast({message: t('error_cart_link'), type: 'danger'});
        }

        setShowSpinner(false);
    }

    const renderCardTipHTML = () => {
        let key = '';

        if (!event?.is_blended) {
            if (!event?.can_buy_credit) {
                key = event?.allow_reenroll ? 'exams_credit_with_classes_text' : 'exams_no_credits';
            } else if (event?.allow_reenroll === false) {
                key = 'rematricula_disabled_closed_shop';
            } else if (event?.is_exam_credit_cart) {
                key = 'exams_credit_text';
            } else if (event?.is_b2b_enroll) {
                key = event.disable_cart_for_b2b ? 'rematricula_disabled_b2b' : 'rematricula_b2b_online';
            } else if (event?.is_project) {
                key = 'project_exams_credit_text';
            }
            else if (event?.has_classes) {
                key = 'exams_credit_with_classes_text';
            } else {
                key = 'exams_credit_no_classes_text';
            }
        }

        // if (!event?.is_blended) {
        //     if (event?.can_buy_credit) {
        //         if (event?.allow_reenroll === false) {
        //             key = 'rematricula_disabled_closed_shop';
        //         } else if (event?.is_exam_credit_cart) {
        //             key = 'exams_credit_text';
        //         } else if (event?.is_b2b_enroll) {
        //             if (event.disable_cart_for_b2b) {
        //                 key = 'rematricula_disabled_b2b';
        //             } else {
        //                 key = 'rematricula_b2b_online';
        //             }
        //         } else if (event?.is_project) {
        //             key = 'project_exams_credit_text';
        //         } else if (event?.has_classes) {
        //             key = 'exams_credit_with_classes_text';
        //         } else {
        //             key = 'exams_credit_no_classes_text';
        //         }
        //     } else {
        //         key = 'exams_no_credits';
        //         if (event?.allow_reenroll) {
        //             key = 'exams_credit_with_classes_text';
        //         }
        //     }
        // }

        if (key !== '') {
            return (
                <div>
                    <hr className='separator-xxs'/>
                    <div className="font-14 sm-col-70"
                     dangerouslySetInnerHTML={{__html: t(key)}}/>
                </div>
            )
        }
    }

    return (
        <Card className='m-top' smOnly={false}>
            <div className='d-flex flex-space-between flex-column sm-no-flex-column'>
                <div className='sm-col-70'>
                    <div className='t-upper font-color-879CA1 font-14'>{event.formative_action_code}</div>
                    <div className='font-20 m-top-half'>{event.formative_action_title}</div>
                </div>
                <div className='sm-col-30 d-flex flex-center-y m-top sm-no-m-top'>
                    {event.has_exam_credit &&
                        <ButtonGhost className='t-upper full-width font-14' onClick={handleClick}>
                            {t('Reservar Plaza')}
                        </ButtonGhost>
                    }
                     {!event.has_exam_credit && event.can_buy_credit && !event.disable_cart_for_b2b && event.is_exam_credit_cart &&
                         // (!event.is_blended || event.is_exam_credit_cart) &&
                         <ButtonSpinner className='full-width t-upper font-14'
                                           classNameContainer='full-width'
                                           showSpinner={showSpinner}
                                           onClick={handleCreateCart}
                                           disabled={!event.cart_url  || showSpinner || event?.allow_reenroll === false}>
                                {t('Comprar derechos de examen')}
                            </ButtonSpinner>
                    }
                    {!event.has_exam_credit && event.allow_reenroll && !event.can_buy_credit &&
                        <ButtonSpinner className='full-width t-upper font-14'
                                       classNameContainer='full-width'
                                       showSpinner={showSpinner}
                                       onClick={handleCreateCart}
                                       disabled={!event.cart_url  || showSpinner || event?.allow_reenroll === false}>
                            {t('Comprar rematricula')}
                        </ButtonSpinner>
                    }
                </div>
            </div>
            {!event.has_exam_credit && renderCardTipHTML()}
        </Card>
    )
}

CardUpcomingExamView = connect(
    ({}) => ({}),
    {setExamSelected})(CardUpcomingExamView);


export default ({...rest}) => {
    return (<CardUpcomingExamView {...rest} />);
}
